import axios from "axios";
import { ExperiencesShopRequest, ExperiencesShopResponse } from "redmond";
import { config } from "../../config";
import { experiencesShopApiPrefix } from "../paths";

export const fetchExperienceShop = async (
  body: ExperiencesShopRequest
): Promise<ExperiencesShopResponse> => {
  const res = await axios.post(experiencesShopApiPrefix, body, {
    baseURL: config.baseURL,
  });

  if (res.data.Response === "Failure") {
    throw new Error(res.data.value);
  }
  return res.data.value;
};
